import React, { useState } from "react";
import PrimaryButton from "../Buttons/PrimaryButton";
import SubmitButton from "../Buttons/SubmitButton";
import SignatureField from "../Inputs/SignatureField";
import { db } from "../../firebase";
import { doc, updateDoc } from "firebase/firestore";

const Step4 = ({
  vehicles,
  tarifsBlock,
  firstVehicle,
  onBack,
  onSubmit,
  setValue,
  documentId,
  signatureUrl,
  setSignatureURL,
  setSignatureImage,
  isSignatureValid,
  setIsSignatureValid,
}) => {
  const [isVehiclesVisible, setVehiclesVisible] = useState(false);
  const [isTotalVisible, setTotalVisible] = useState(false);
  const [isClientInfoVisible, setClientInfoVisible] = useState(false);

  // Fonction pour vérifier le type de fichier
  const getFileExtension = (url) => {
    if (url) {
      const parts = url.split(".");
      const fileExtension = parts[parts.length - 1];
      const cleanExtension = fileExtension.split("?")[0];
      return cleanExtension;
    }
  };

  const isImage = (url) => {
    if (url) {
      const extension = getFileExtension(url).toLowerCase();
      console.log(extension);
      return ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension);
    }
  };

  const saveSign = async () => {
    const formdocRef = doc(db, "forms", documentId);
    await updateDoc(formdocRef, {
      clientSignature: signatureUrl || "",
    });
  };

  const openLinkInNewTab = (url) => {
    window.open(url, "_blank");
  };

  const isValid = (value) => {
    return value && value !== "0"; // Vérifie que la valeur n'est ni vide ni "0"
  };

  return (
    <div className="step-4">
      {/* Section des informations de l'assuré */}
      <div className="client-info">
        <h2 className="text-lg font-bold mb-2">Informations de l'assuré</h2>
        <button
          type="button"
          onClick={() => setClientInfoVisible(!isClientInfoVisible)}
          className="text-blue-500 mb-2"
        >
          {isClientInfoVisible ? "Cacher les détails" : "Afficher les détails"}
        </button>

        {isClientInfoVisible && (
          <div className="client-details border p-2 mb-2 rounded">
            {isValid(firstVehicle.firstName) && (
              <p>
                <strong>Prénom :</strong> {firstVehicle.firstName}
              </p>
            )}
            {isValid(firstVehicle.lastName) && (
              <p>
                <strong>Nom :</strong> {firstVehicle.lastName}
              </p>
            )}
            {isValid(firstVehicle.raisonSociale) && (
              <p>
                <strong>Raison sociale :</strong> {firstVehicle.raisonSociale}
              </p>
            )}
            <p>
              <strong>Adresse :</strong>{" "}
              {`${firstVehicle.street}, ${firstVehicle.city}, ${firstVehicle.country}`}
            </p>
            <p>
              <strong>Email :</strong> {firstVehicle.email}
            </p>
            <p>
              <strong>Téléphone principal :</strong>{" "}
              {`${firstVehicle.phoneNumber}`}
            </p>
            <p>
              <strong>Téléphone secondaire :</strong>{" "}
              {`${firstVehicle.secondaryPhoneNumber}`}
            </p>
            {`${new Date(firstVehicle.startDate).toLocaleDateString()}`}
            <p>
              <strong>Date de début souhaité :</strong>{" "}
            </p>
          </div>
        )}
      </div>

      {/* Section des véhicules */}
      <div className="vehicles-summary">
        <h2 className="text-lg font-bold mb-2">Récapitulatif des véhicules</h2>
        <button
          type="button"
          onClick={() => setVehiclesVisible(!isVehiclesVisible)}
          className="text-blue-500 mb-2"
        >
          {isVehiclesVisible ? "Cacher les détails" : "Afficher les détails"}
        </button>

        {isVehiclesVisible && (
          <div className="vehicle-list">
            {vehicles.map((vehicle, index) => (
              <div
                key={index}
                className="vehicle-item border p-2 mb-2 rounded flex flex-row justify-between flex-wrap"
              >
                <div>
                  {isValid(vehicle.brand) && (
                    <h3 className="font-semibold">{`${vehicle.brand} ${vehicle.model}`}</h3>
                  )}
                  {isValid(vehicle.vehicleType) && (
                    <p>
                      <strong>Type de véhicule :</strong> {vehicle.vehicleType}
                    </p>
                  )}
                  {isValid(vehicle.carColor) && (
                    <p>
                      <strong>Couleur :</strong> {vehicle.carColor}
                    </p>
                  )}
                  {isValid(vehicle.usage) && (
                    <p>
                      <strong>Usage :</strong> {vehicle.usage}
                    </p>
                  )}
                  {isValid(vehicle.duration) && (
                    <p>
                      <strong>Durée :</strong> {vehicle.duration}
                    </p>
                  )}
                  {isValid(vehicle.immat) && (
                    <p>
                      <strong>Immatriculation :</strong> {vehicle.immat}
                    </p>
                  )}
                  {isValid(vehicle.payload) && (
                    <p>
                      <strong>Charge utile :</strong> {vehicle.payload}
                    </p>
                  )}
                  {isValid(vehicle.manufactureYear) && (
                    <p>
                      <strong>Année de fabrication :</strong>{" "}
                      {vehicle.manufactureYear}
                    </p>
                  )}
                  {isValid(vehicle.firstRegistrationYear) && (
                    <p>
                      <strong>Année de circulation :</strong>{" "}
                      {vehicle.firstRegistrationYear}
                    </p>
                  )}
                  {isValid(vehicle.fiscalPower) && (
                    <p>
                      <strong>Puissance fiscale :</strong> {vehicle.fiscalPower}
                    </p>
                  )}
                  {isValid(vehicle.numberOfCards) && (
                    <p>
                      <strong>Nombre de cartes :</strong>{" "}
                      {vehicle.numberOfCards}
                    </p>
                  )}
                  {isValid(vehicle.cards) && (
                    <p>
                      <strong>Cartes :</strong> {vehicle.cards}
                    </p>
                  )}
                  {isValid(vehicle.isInSale) && (
                    <p>
                      <strong>En vente :</strong> {vehicle.isInSale}
                    </p>
                  )}
                  {isValid(vehicle.isDoublePedal) && (
                    <p>
                      <strong>Double pédale :</strong> {vehicle.isDoublePedal}
                    </p>
                  )}
                  {isValid(vehicle.seats) && (
                    <p>
                      <strong>Nombre de sièges :</strong> {vehicle.seats}
                    </p>
                  )}
                  {isValid(vehicle.tonnage) && (
                    <p>
                      <strong>Tonnes :</strong> {vehicle.tonnage}
                    </p>
                  )}
                  {isValid(vehicle.realseats) && (
                    <p>
                      <strong>Sièges réels :</strong> {vehicle.realseats}
                    </p>
                  )}
                  {isValid(vehicle.trailers) && (
                    <p>
                      <strong>Remorques :</strong> {vehicle.trailers}
                    </p>
                  )}
                  {isValid(vehicle.otherspecial) && (
                    <p>
                      <strong>Autre spécial :</strong> {vehicle.otherspecial}
                    </p>
                  )}
                </div>
                <div className="border rounded-xl border-gray-100 w-[220px] h-auto flex justify-center items-center">
                  {isImage(vehicle.document) ? (
                    <img
                      src={vehicle.document}
                      alt="Certificat d'immatriculation"
                      className="w-full h-auto rounded"
                    />
                  ) : (
                    <PrimaryButton
                      type="button"
                      label="Visualiser le PDF"
                      onClick={() => openLinkInNewTab(vehicle.document)}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Section des totaux */}
      <div className="total-summary">
        <h2 className="text-lg font-bold mb-2">Total à payer</h2>
        <button
          type="button"
          onClick={() => setTotalVisible(!isTotalVisible)}
          className="text-blue-500 mb-2"
        >
          {isTotalVisible ? "Cacher les détails" : "Afficher les détails"}
        </button>

        {isTotalVisible && (
          <div className="total-details border p-2 mb-2 rounded">
            <div className="total-details border p-2 mb-2 rounded">
              <p>
                <strong>Tarif (prime nette) :</strong>{" "}
                {tarifsBlock.totalPrice.toFixed(2)} $
              </p>
              <p>
                <strong>TVA (16%):</strong> {tarifsBlock.TVA.toFixed(2)} $
              </p>
              <p>
                <strong>ARCA (2%):</strong> {tarifsBlock.ARCA.toFixed(2)} $
              </p>
              {tarifsBlock.discount ? (
                <p>
                  <strong>Remise :</strong> {tarifsBlock.discount * 100} %
                </p>
              ) : (
                <></>
              )}
              <p>
                <strong>Montant total TTC :</strong>{" "}
                {tarifsBlock.finalPrice.toFixed(2)} $
              </p>
            </div>
          </div>
        )}
      </div>

      <div className="signature-section">
        <h2 className="text-lg font-bold mb-2">Signature du client</h2>
        <SignatureField
          setSignatureImage={setSignatureImage}
          setValue={setValue}
          setSignatureURL={setSignatureURL}
          isSignatureValid={isSignatureValid}
          setIsSignatureValid={isSignatureValid}
          fieldName="clientSignature"
        />
      </div>

      {/* Boutons de validation et retour */}
      <div className="actions mt-4">
        <PrimaryButton
          type="button"
          onClick={onBack}
          label={"Retour"}
          className="bg-gray-300 py-2 px-4 rounded mr-2"
        />
        <SubmitButton
          type="button"
          onClick={async () => {
            await saveSign();
            onSubmit();
          }}
          disabled={isSignatureValid}
          label={"Valider"}
          className="bg-blue-500 text-white py-2 px-4 rounded"
        />
      </div>
    </div>
  );
};

export default Step4;
